import React from 'react'
import Math from "lodash"
import moment from "moment"
import './components.css'
import PropTypes from 'prop-types'
import {FacilityCardEmptyImage} from "./FacilityCardEmptyImage";

FacilityCard.propTypes = {
    onClick: PropTypes.func,
    facility: PropTypes.object,
    enableEmptyFacilityText: PropTypes.bool
}

export const formatCurrency = (value) =>
    Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
    }).format(value ? value : '0.00');

export const convertToTitleCase = (str) => {
    if ((str == null) || (str==''))
        return false;
    else
        str = str.toString();

    return str.replace(/\w\S*/g,
        function(txt){return txt.charAt(0).toUpperCase() +
            txt.substr(1).toLowerCase();});
}

export default function FacilityCard(props) {
    const {
        facility,
    } = props

    const [activeIndex, setActiveIndex] = React.useState(0);

    return <div
                className={'facility-card'}
                onClick={() => {
                    if(props.onClick) {
                        props.onClick()
                    }
                }}
            >
                <div>
                    {facility.pictureCount > 0 &&
                        <div className={'facility-card-avatar'}
                             style={{
                                 backgroundImage:'url("'+facility.photos[activeIndex]+'")'
                        }}>
                        </div>
                    }

                    {facility?.pictureCount == 0 &&
                        <FacilityCardEmptyImage enableWatermark url={facility?.profilePicURL}/>
                    }

                </div>
                <div>
                    <div className={'facility-card-name-wrapper'}>
                        {convertToTitleCase(facility.clientName.replace('@', 'at'))}
                    </div>
                </div>
                <div className={'facility-card-info-wrapper'}>

                    <div className={'facility-card-west-wrapper'}>

                        {((facility.maxRate != null && facility.maxRate > 0) || facility.maxPay) &&
                            <div className={'facility-card-rate-wrapper'}>
                                <div className={'facility-card-caption'}>Earn Up To</div>
                                <div className={'facility-card-dollars'}>{formatCurrency(facility.maxPay ? facility.maxPay : facility.maxRate * 7.5)}</div>
                                <div className={'facility-card-sub-caption'}>Per Shift</div>
                            </div>
                        }

                        {((facility.maxRate == null || facility.maxRate == 0) && (facility.clientId && (facility.statusId !== 'I' && facility.statusId !== 'P'))) &&
                            <div className={'facility-card-rate-wrapper'}>
                                <div className={'facility-card-caption'}>&nbsp;</div>
                                <div className={'facility-card-dollars'}>&nbsp;</div>
                                <div className={'facility-card-sub-caption'}>&nbsp;</div>
                            </div>
                        }

                        {((facility.maxRate == null || facility.maxRate == 0) && (!facility.clientId || (facility.statusId === 'I' || facility.statusId === 'P'))) &&
                            <div style={{marginLeft:'4px'}} className={['facility-card-rate-wrapper']}>
                                <div className={'facility-card-caption'}>Want To</div>
                                <div className={'facility-card-dollars'}>Work</div>
                                <div className={'facility-card-sub-caption'}>Here?</div>
                            </div>
                        }



                    </div>

                    <div className={'facility-card-center-wrapper'}>
                        <div style={{marginTop:'8px', textAlign:'center'}} className={'facility-card-sub-caption'}></div>
                    </div>

                    <div className={'facility-card-east-wrapper'}>
                        <div>
                            {facility.earliestShift && facility.latestShift &&
                                <div>
                                    {/* Displaying only one shift time if both the earliest shift and latest shift are on the same day */}
                                    {moment(facility.earliestShift).format('MMM DD') ===
                                    moment(facility.latestShift).format('MMM DD') ? (
                                        <div className={'facility-card-date-wrapper'}>
                                            {`${moment(facility.earliestShift).format('MMM DD')}`}
                                        </div>
                                    ) : (
                                        <div className={'facility-card-date-wrapper'}>
                                            {`${moment(facility.earliestShift).format('MMM DD')}`} -{' '}
                                            {`${moment(facility.latestShift).format('MMM DD')}`}
                                        </div>
                                    )}
                                </div>
                            }
                        </div>
                        {/*<div>Within {Math.round(facility.distance)} miles</div>*/}
                    </div>

                </div>
            </div>
}
